module.exports = __webpack_public_path__ + "assets/img/enterprise5-2-1@2x.9d79e5ad.png";